'use client'
import { Grid, Collapse } from '@achieve/ascend'
import { Button } from 'components/Button'
import { useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather'
import classNames from 'classnames'
import { CardValueProp } from '@/components/Cards'
import SITE_ENVIRONMENTS from '@/constants/websites'

const renderItem = (id, item, useCards, config, siteEnv) => {
  return (
    <div
      data-item-id={id}
      className={classNames(
        'basis-full ',
        config.itemsByrow === 4 ? 'lg:basis-[20.833333%]' : 'lg:basis-[29.1667%]',
        (id + 1) % config.itemsByrow == 0 || !config.dividerToggle
          ? ''
          : 'border-none lg:border-r lg:border-solid lg:border-y-0 lg:border-l-0 lg:border-[#42546b] lg:pr-4',
        id + 1 > config.itemsByrow && 'pt-0 lg:pt-[48px]',
        { '[&:last-child>div>div]:mb-0': siteEnv === SITE_ENVIRONMENTS.FDR }
      )}
      key={`card-${id}`}
    >
      <div data-testid="value-prop-grid-card-item" className={'lg:max-w-[305px] lg:m-auto'}>
        <CardValueProp
          cardStyle={config.cardStyle}
          content={item}
          breakline={config.breakline}
          pos={id}
          gridConfig={config.gridConfig}
          className={config?.jsonContent?.className}
        />
      </div>
    </div>
  )
}

function ValuePropsCollapse({
  grid,
  maxOnMobile,
  useCards,
  sectionVariationObject,
  config,
  event = null,
}) {
  const [showMore, setShowMore] = useState(false)
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || 'achieve'

  return (
    <>
      <div className="block lg:hidden">
        <Collapse in={showMore} data-testid="collapsed-container" className="w-full">
          <Grid container justifyContent="left" gap="1rem">
            {grid?.gridItemsCollection?.items?.map((item, idx) => {
              if (idx < maxOnMobile) return null
              return renderItem(idx, item, useCards, config, siteEnv)
            })}
          </Grid>
        </Collapse>
        <Grid container justifyContent="center">
          <Button
            variant="text"
            onClick={() => setShowMore(!showMore)}
            endIcon={showMore ? <ChevronUp /> : <ChevronDown />}
            track={{
              ...{
                list_name: 'VALUE PROPS ACCORDION LESS/MORE',
                click_id: showMore ? 'Less' : 'More',
                click_text: showMore ? 'Show less' : 'Show more',
              },
              ...event,
              sectionVariationObject,
            }}
            data-testid="show-more-less-value-props-button"
          >
            {showMore ? 'Show less' : 'Show all'}
          </Button>
        </Grid>
      </div>
    </>
  )
}

export { ValuePropsCollapse }
